export default {
  data() {
    return {
      origin: process.env,
      orderId: "",
      finishMsg: "",
    };
  },
  created() {
    this.$store.commit("app/setShowTitle", true);
    this.$store.commit("app/setSellerMenuVisible", false);

    const { orderId, finishMsg } = this.$route.query;
    this.orderId = orderId;
    this.finishMsg = finishMsg;
  },
};
